import { jsx as r, jsxs as c } from "react/jsx-runtime";
import a, { useTheme as m } from "styled-components";
import d from "../../../icons/clear.js";
import { sizes as u } from "../../../theme/utils/styleUtils.js";
import h from "../../IconButton/IconButton.js";
const f = a(h).withConfig({
  displayName: "StyledIconButton"
})([
  "&&.iconButtonRoot{width:16px;height:16px;margin-right:8px;}"
]), x = a.div.withConfig({
  displayName: "AdornmentContainer"
})([
  "display:inline-flex;position:absolute;right:0;align-items:center;height:12px;"
]), C = (e) => {
  let t = !1;
  return (e === "text" || e === "email" || e === "password" || e === "search" || e === "tel" || e === "url" || e === "number") && (t = !0), t;
}, i = ({ className: e, name: t, onClear: n, ...l }) => {
  const o = m(), s = () => {
    n && n({
      type: "change",
      target: {
        name: t,
        value: "",
        type: "text",
        localName: "input",
        tagName: "INPUT",
        nodeName: "INPUT"
      },
      currentTarget: {
        name: t,
        value: "",
        type: "text",
        localName: "input",
        tagName: "INPUT",
        nodeName: "INPUT"
      },
      eventPhase: 3,
      bubbles: !0,
      cancelable: !1,
      defaultPrevented: !1,
      isTrusted: !0
    });
  };
  return /* @__PURE__ */ r(f, {
    className: `clearTextButtonIcon${e ? ` ${e}` : ""}`,
    name: t,
    size: u.medium,
    onClick: s,
    tabIndex: -1,
    flavor: o.isLightTheme ? o.colors.grey500 : o.colors.darkGrey300,
    variant: "normal",
    ...l,
    children: /* @__PURE__ */ r(d, {})
  });
};
i.displayName = "ClearText";
const b = (e, t, n) => /* @__PURE__ */ c(x, {
  children: [
    /* @__PURE__ */ r(i, {
      name: e,
      onClear: t
    }),
    n
  ]
});
export {
  b as addClearTextAdornment,
  i as default,
  C as isTextType
};
